import { render, staticRenderFns } from "./AlexChat.vue?vue&type=template&id=b6f27652&scoped=true&"
import script from "./AlexChat.vue?vue&type=script&lang=js&"
export * from "./AlexChat.vue?vue&type=script&lang=js&"
import style0 from "./AlexChat.vue?vue&type=style&index=0&id=b6f27652&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f27652",
  null
  
)

export default component.exports